import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../../../theme';
/**
 * `LociWordmark` renders the LOCI · {CITY} lockup in Space Grotesk 700.
 *
 * Consuming apps must load Space Grotesk (e.g. via `next/font/google`) for the
 * component to render with the intended typeface; otherwise it falls back to
 * the system sans-serif stack.
 */
export const LociWordmark = forwardRef(({ city, size = 16, color, cityColor, letterSpacing = '0.08em', style, ...rest }, ref) => {
    const theme = useTheme();
    const resolvedColor = color ?? theme.colors.text;
    const resolvedCityColor = cityColor ?? resolvedColor;
    const rootStyle = {
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: '0.35em',
        fontFamily: '"Space Grotesk", sans-serif',
        fontWeight: 700,
        fontSize: size,
        letterSpacing,
        lineHeight: 1,
        ...style,
    };
    return (_jsxs("span", { ref: ref, style: rootStyle, ...rest, children: [_jsx("span", { style: { color: resolvedColor }, children: "LOCI" }), _jsx("span", { "aria-hidden": "true", style: { color: resolvedColor, opacity: 0.8 }, children: "\u00B7" }), _jsx("span", { style: { color: resolvedCityColor }, children: city })] }));
});
LociWordmark.displayName = 'LociWordmark';
